.chart {
    width: calc(100% - 301px);
    position: absolute;
    bottom: 0;
    left: 0;
}
